module.exports = __webpack_public_path__ + "static/media/init.a439a893.jpg";